/**
 * Utility functions for date operations
 */

/**
 * Maps backend day names to JavaScript Date.getDay() indices
 * Backend: ["MONDAY", "TUESDAY", ...] -> JS: 0=Sunday, 1=Monday, ...
 */
const DAY_NAME_TO_INDEX: Record<string, number> = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
};

/**
 * Determines if a given date falls on a working day
 * @param date - The date to check
 * @param workingDays - Array of working day names from backend (e.g., ["MONDAY", "TUESDAY"])
 * @returns true if the date is a working day, false otherwise
 */
export const isWorkingDay = (date: Date, workingDays: string[]): boolean => {
  // Fail-safe: if no working days configured, allow all days
  if (!workingDays || workingDays.length === 0) {
    return true;
  }

  const dayOfWeek = date.getDay();
  
  // Check if the current day of week is in the working days array
  const dayNames = Object.keys(DAY_NAME_TO_INDEX);
  const currentDayName = dayNames[dayOfWeek];
  
  return workingDays.includes(currentDayName);
};
